import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@services/baseQuery/baseQueryWithReauth";
import { EFeatureFlags } from "../enums/EFeatureFlags";

export const featureFlagsApi = createApi({
  reducerPath: "featureFlagsApi",
  tagTypes: ["featureFlags"],
  baseQuery: baseQueryWithReauth(import.meta.env.VITE_APP_YAPI_DOCMGR || ""),
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<EFeatureFlags[], void>({
      query: () => "api/v1/featureManagement/enabledFeatures",
    }),
  }),
});

export const { useGetFeatureFlagsQuery, useLazyGetFeatureFlagsQuery } =
  featureFlagsApi;
